// Admin Page State

export const adminPageInitialState = {
  // Reserved for future admin tabs/sections
  activeTab: "overview",
  // Task management
  currentTaskId: null,
  taskStatus: null, // 'pending', 'processing', 'completed', 'failed'
  taskError: null,
  showDatabaseUpdatesSection: false,
  showEmployeeUpdatesSection: false,
  showAdminUsersSection: false,
  showProjectUnitsSection: false,
};
